import "./Button.css";

export function Button({onClick, children, className = "", type = "button", size, color, variant = "filled", ...props}) {
    return (
        <button
            {...props}
            className={`button ${className} --size-${size} --color-${color} --variant-${variant}`}
            onClick={onClick}
            type={type}
        >
            {children}
        </button>
    );
}